import { render, staticRenderFns } from "./CircleFab.vue?vue&type=template&id=2c2c07a2&lang=pug&"
import script from "./CircleFab.vue?vue&type=script&lang=js&"
export * from "./CircleFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CircleFab.vue"
export default component.exports